export const TAB_NAME = "TAB_NAME";
export const SWITCH_HAM = "SWITCH_HAM";
export const SET_TODAY = "SET_TODAY";

export const setTabName = (tabName) => {
  return {
    type: TAB_NAME,
    payload: tabName,
  };
};
export const setSwitchHam = () => {
  return {
    type: SWITCH_HAM,
  };
};
export const setToday = (today) => {
  return {
    type: SET_TODAY,
    payload: today,
  };
};
